module.exports = __webpack_public_path__ + "img/school_banner.f97ce477.png";